<h1 mat-dialog-title align="center">Confirmación</h1>
<mat-dialog-content class="content">
  <mat-icon align="center" class="iconHelp">help_outline</mat-icon>
  <p>{{data.message}}</p>
  <p>{{data.message2}}</p>
</mat-dialog-content>
<mat-dialog-actions class="actions">
  <button mat-raised-button [mat-dialog-close]="true">{{data.confirmAction}}</button>
  <button mat-raised-button mat-dialog-close>Cancelar</button>
</mat-dialog-actions>